import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AudioComponent } from './audio.component';
import { ButtonModule } from '../button/button.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import {ProgressModule} from '../progress/progress.module';

@NgModule({
    imports: [
        CommonModule,
        ButtonModule,
        SvgIconModule,
        ProgressModule,
    ],
  declarations: [
    AudioComponent
  ],
  exports: [
    AudioComponent
  ]
})
export class AudioModule {}
